import { render, staticRenderFns } from "./commentDesp.vue?vue&type=template&id=286f2062&"
import script from "./commentDesp.vue?vue&type=script&lang=js&"
export * from "./commentDesp.vue?vue&type=script&lang=js&"
import style0 from "./commentDesp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports